import Button from 'components/shared/Button.styled';
import styled, { css } from 'styled-components';
import { color, fontSize, screen, spacing, zindex } from 'theme';

export const StyledWrapper = styled.div`
  padding-bottom: ${spacing('xl6')};
`;

export const StyledFooter = styled.div<{
  previewMode?: boolean;
}>`
  background-color: ${color('midnight_850')};
  color: ${color('midnight_200')};
  padding: ${spacing('lg')};
  text-align: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${zindex('bottomBar')};

  ${({ previewMode }) =>
    previewMode &&
    css`
      text-align: left;
    `}

  ${({ previewMode }) =>
    !previewMode &&
    css`
      ${StyledFooterActions} {
        justify-content: center;
      }
    `}
`;

export const StyledFooterActions = styled.div`
  display: flex;
  gap: ${spacing('md')};

  ${Button} {
    flex: 0 0 auto;
    margin: 0;
  }
`;

export const StyledFooterTag = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledFooterButtons = styled.div`
  display: none;
  gap: ${spacing('md')};

  @media (min-width: ${screen('md')}) {
    display: flex;
  }
`;

export const StyledFooterMobileButtons = styled.div`
  display: flex;
  gap: ${spacing('md')};

  @media (min-width: ${screen('md')}) {
    display: none;
  }
`;

export const StyledFooterMobileDropUp = styled.div`
  position: relative;
`;

export const StyledFooterEdit = styled.div`
  flex: 1 1 auto;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
`;

export const StyledFooterHeader = styled.div`
  text-transform: uppercase;
  font-size: ${fontSize('sm')};
  margin-bottom: ${spacing('md')};
`;
